export default {
    currentBatch:  (state) => state.currentBatch,
    history:       (state) => state.history,
    isPolling:     (state) => state.isPolling,
    isDispatching: (state) => state.isDispatching,
}
